import './SelectQuestionCheckbox.scss';

import * as React from 'react';

import { SlCheckbox } from '@shoelace-style/shoelace/dist/react';
import { QuestionTypes } from '@showbie-socrative/socrative-utils';

import { QuestionDetails } from '~teacher/components/QuizEditor/GenerateQuestionDialog/QuestionDetails';

interface SelectQuestionCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  id: string;
  questionType: QuestionTypes;
  explanation?: string;
  text: string;
  answers?: Array<{
    order: number;
    text: string;
    isCorrect: boolean;
  }>;
}

export function SelectQuestionCheckbox({
  id,
  questionType,
  text,
  checked,
  onChange,
  answers = [],
  explanation,
}: SelectQuestionCheckboxProps) {
  return (
    <div className="select-question-checkbox-wrapper flex items-start gap-4 p-5 shadow-inset-border-t">
      <div className="py-3">
        <SlCheckbox
          className="pt-1 m-0"
          key={id}
          role="checkbox"
          onSlChange={(e) => {
            onChange((e.target as any).checked);
          }}
          checked={checked}
        >
          <span className="sr-only">{text}</span>
        </SlCheckbox>
      </div>
      <div className="flex-grow min-w-0">
        <QuestionDetails
          questionType={questionType}
          questionText={text}
          answers={answers}
          explanation={explanation}
        />
      </div>
    </div>
  );
}
